/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : convertNeuDSLToGraph.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
export function convertNeuDSLToGraph(dsl) {
  const nodes = [];
  const edges = [];

  const dslNodes = dsl.Nodes;
  const visited = new Set();

  const base = (id) => id.replace("_display", "").replace("_decision", "");

  function walk(dslId) {
    if (!dslId || visited.has(dslId)) return;
    visited.add(dslId);

    const node = dslNodes[dslId];
    if (!node) return;

    /* START */
    if (node.Type === "Forward") {
      nodes.push({
        id: dslId,
        type: "start",
        position: { x: 100, y: 100 },
        data: {},
      });

      edges.push({
        id: `e-${dslId}-${node.GoTo}`,
        source: dslId,
        target: base(node.GoTo),
      });

      walk(node.GoTo); // DO NOT strip
      return;
    }

    /* DISPLAY */
    if (node.Type === "Action" && dslId.endsWith("_display")) {
      const qid = base(dslId);
      const decision = dslNodes[`${qid}_decision`];

      nodes.push({
        id: qid,
        type: "question",
        position: { x: 300, y: nodes.length * 150 },
        data: {
          questionText: node.Label,
          answers: decision.Choices.map((c, i) => ({
            id: `a${i}`,
            label: c.Label,
          })),
        },
      });

      walk(`${qid}_decision`);
      return;
    }

    /* DECISION */
    if (node.Type === "Decision") {
      const qid = base(dslId);

      node.Choices.forEach((c, i) => {
        if (!c.GoTo) return;

        edges.push({
          id: `e-${qid}-${base(c.GoTo)}-${i}`,
          source: qid,
          sourceHandle: `a${i}`,
          target: base(c.GoTo),
        });

        walk(c.GoTo); // 🔥 DO NOT strip
      });
      return;
    }

    /* END */
    if (node.Type === "Abort" || node.Type === "Complete") {
      const backendOutcome = node.Output?.outcome;
      nodes.push({
        id: dslId,
        type: "end",
        position: { x: 600, y: nodes.length * 150 },
        data: {
          outcome: {
            type: "TICKET_DECISION",
            value: node.Type === "Complete" ? backendOutcome : "DO_NOT_CREATE",
          },
        },
      });
    }
  }

  walk(dsl.EntryNode);

  return { nodes, edges };
}
